<template>
	<div class="translate-changer">
    <el-dropdown @command="changeLang">
      <FlagImage 
        :lang="selectedLang.code" 
        width="30px" 
        class="flag-selected"
      />
      <el-dropdown-menu 
        slot="dropdown" 
        width="100px"  
      >
        <el-dropdown-item             
          v-for="(lang, i) in otherLang"
          :key="`Lang${i}`"
          class="text-left pt-2 pb-2"
          :command="lang"
        >
          <a @click.prevent>
            <FlagImage :lang="lang.code"  width="40px" class="flag-list" :alt="lang.code"/>
            {{ lang.label }}
          </a>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

	</div>
</template>

<script>
// import {mapActions, mapGetters, mapState} from 'vuex';
import {mapActions} from 'vuex';
import FlagImage from '@/components/FlagImage/';

export default {
  name: "TranslateSelect",
  components: {
    FlagImage
  },
  data () {
    return {
      showMenu: false,
      selectedLangCode: 'en'
      // langs: [
			// 	{ code: 'en', label: 'EN', img: "en.svg" },
			// 	{ code: 'pt', label: 'PT', img: "pt.svg" },
			// 	{ code: 'pt_br', label: 'PT-BR', img: "pt-br.svg" }
			// ]
		}
  },
  computed: {
    // ...mapState('utils', 'languages'),
    // ...mapGetters('utils', 'selectedLanguage'),
    languages() {
      return this.$store.state.utils.languages;
    },
    selectedLanguageId() {
      return this.$store.state.utils.selectedLanguageId;
    },
    selectedLang() {
      return this.languages.find(lang => {
        return lang.id === this.selectedLanguageId;
      });
    },
    otherLang() {
      return this.languages.filter(lang => {
        return lang.id !== this.selectedLanguageId;
      });
    }
  },
  mounted() {
    if (this.$route.query.lang) {
      const LANG_CODE = this.$route.query.lang;
      this.selectedLangCode = LANG_CODE;
      localStorage.LangCode = LANG_CODE;
      this.$i18n.locale = LANG_CODE;

      let lang = this.languages.find(lang => {
        return lang.code === this.$route.query.lang;
      });

      if (lang) this.setSelectedLanguageId(lang.id);

    } else if (localStorage.LangCode) {
      this.selectLangByCode(localStorage.LangCode);
    } else {
      const LANG_CODE = document.location.href;
      if (LANG_CODE.includes('br')) {
        this.selectLangByCode('pt_br'); 
      } else if (LANG_CODE.includes('pt')) {
        this.selectLangByCode('pt');
      } else {
        this.selectLangByCode('en');
      }
    }

  },
  methods: {
    ...mapActions("utils", ["setSelectedLanguageId"]),
    changeLang(command) {
      let lang = command;
      this.$i18n.locale = lang.code;
      this.selectedLangCode = lang.code;
      localStorage.LangCode = lang.code;

      this.setSelectedLanguageId(lang.id);
    },
    selectLangByCode(code) {
      this.selectedLangCode = code;
      this.$i18n.locale = code;
      localStorage.LangCode = code;

      const lang = this.languages.find(lang => {
        return lang.code === code;
      });

      this.setSelectedLanguageId(lang.id);
    }
  }
};
</script>

<style lang="scss" scoped_>
  @import 'src/assets/css/patterns.scss';

	.translate-changer {
		opacity: 1;
		color: #ccc;
		text-indent: 5px;
    transition: opacity 0.8s ease;
    z-index: 10000000;
    font-size: 10px !important;

    @media screen and (max-width: $screen-sm) {
      padding-left: 0px;
      margin-left: 0px !important;
      margin-top: 10px !important;

      .navbar-nav .nav-item {
          margin: 0 0px;

          .nav-link {
            margin: 0px 0px;
            padding: 0px !important;

           &:not(.btn):hover {
                background-color: transparent !important;
            }
          }
      }

    }

    .title-company-actived, .dropdown-item {
      font-size: 14px !important;

      &:active {
        background-color: transparent !important;
        border: 1px solid transparent !important;
      }
    }
    .dropdown {
      .dropdown-toggle {
        @media screen and (max-width: $screen-sm) {
          padding-left: 0px;
          margin-left: 0px;
        }
      }

      .dropdown-item {
          @media screen and (max-width: $screen-sm) {
            color: #ccc !important;

            img {
              margin-right: 10px;
            }
          }
      }
    }

		.flag-selected {
			width: 40px;
		}

		.flag-list {
			width: 35px;
		}

		&:hover {
			opacity: 1;
		}

		.select {
			width: 50px;
			margin: 0 auto;
			text-align: center;
			text-align-last:center;
			color: $gray-800;
			background: $color-default;
			color: $white;
			text-shadow: 0 1px 0 $black;

			option {
				background: $color-default;
				color: $white;
				text-shadow: 0 1px 0red;
				border: 1px solid $white !important;
				text-align: center;
				padding: 10px;
			}

			.el-input {
				background: $color-default;
			}

			&:focus {
				color: $white;
				text-align: center;
			}

			option {
				text-align: center;
			}
		}
  }
</style>
